module.exports = __webpack_public_path__ + "static/media/mpl-logo.8f631b2f.jpg";